import Link from 'next/link'

import { HstoresLogo } from '@/widgets/Footer/ui/components/footer-bottom/assets/hstoresLogo'
import { SamsungLogo } from '@/widgets/Footer/ui/components/footer-bottom/assets/SamsungLogo'

import {
	WEB_CONSEST_LINK,
	WEB_OFFER_LINK,
	WEB_OFFER_UNISAFE,
	WEB_POLICY_LINK
} from '@/shared/lib/utils/constants/pdfDocs'

import cl from './FooterBottom.module.scss'

export const FooterBottom = () => {
	return (
		<div>
			<ul className={cl.mobileList}>
				<li>
					<Link prefetch={false} href={WEB_POLICY_LINK} target="_blank">
						Политика конфиденциальности
					</Link>
				</li>
				<li>
					<Link prefetch={false} href={WEB_CONSEST_LINK} target="_blank">
						{' '}
						Согласие на обработку персональных данных
					</Link>
				</li>
				<li>
					<Link prefetch={false} href={WEB_OFFER_LINK} target="_blank">
						Оферта
					</Link>
				</li>
				<li>
					<Link href="/sitemap/" prefetch={false}>
						Карта сайта
					</Link>
				</li>
			</ul>
			<div className={cl.root}>
				<div className={cl.top}>
					<small>© 2011-{new Date().getFullYear()} iPort - Магазины Apple Premium Reseller</small>
					<ul>
						<li>
							<Link prefetch={false} href={WEB_POLICY_LINK} target="_blank">
								Политика конфиденциальности
							</Link>
						</li>
						<li>
							<Link prefetch={false} href={WEB_CONSEST_LINK} target="_blank">
								{' '}
								Согласие на обработку персональных данных
							</Link>
						</li>
						<li>
							<Link prefetch={false} href={WEB_OFFER_LINK} target="_blank">
								Оферта
							</Link>
						</li>
						<li>
							<Link prefetch={false} href={WEB_OFFER_UNISAFE} target="_blank">
								Оферта ПО UniSafe
							</Link>
						</li>
						<li>
							<Link href="/sitemap" prefetch={false}>
								Карта сайта
							</Link>
						</li>
					</ul>
				</div>
				<div className={cl.bot}>
					<small>Сеть iPort входит в группу компаний NBCom Group</small>
					<ul>
						<li>
							<Link
								prefetch={false}
								href={'https://www.h-stores.ru/?utm_source=iport&utm_medium=organic&utm_campaign=basement'}
								target={'_blank'}>
								<span style={{ fontSize: `0` }}>h-stores</span>
								<HstoresLogo />
							</Link>
						</li>
						<li>
							<Link
								prefetch={false}
								href={'https://www.samsungstore.ru/?utm_source=iport&utm_medium=organic&utm_campaign=basement'}
								target={'_blank'}>
								<span style={{ fontSize: `0` }}>samsungstore</span>
								<SamsungLogo />
							</Link>
						</li>
					</ul>
				</div>
			</div>
		</div>
	)
}
